//TODO : Refactor after ai
import type { HTMLAttributes, MouseEvent, ReactNode } from "react";

export interface ChipProps extends HTMLAttributes<HTMLSpanElement> {
  children?: ReactNode;
  size?: "sm" | "md" | "lg";
  selected?: boolean;
  onRemove?: () => void;
  icon?: ReactNode;
  avatar?: ReactNode;
}

/** Removable / selectable tag. */
export function Chip({
  children,
  size = "md",
  selected,
  onRemove,
  onClick,
  icon,
  avatar,
  className = "",
  ...rest
}: ChipProps) {
  const remove = (event: MouseEvent<HTMLButtonElement>) => {
    event.stopPropagation();
    onRemove?.();
  };

  return (
    <span
      className={`bui-chip ${className}`}
      data-size={size}
      data-selected={selected || undefined}
      data-interactive={onClick ? "true" : undefined}
      onClick={onClick}
      {...rest}
    >
      {avatar}
      {icon}
      {children}
      {onRemove && (
        <button
          type="button"
          className="bui-chip__close"
          onClick={remove}
          aria-label="Filter entfernen"
        >
          <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round">
            <path d="M6 6l12 12M18 6 6 18" />
          </svg>
        </button>
      )}
    </span>
  );
}
